export default __webpack_public_path__ + "static/devesecops-support1-be54d2baaef109819d9cf0121b72a679.jpg";